import { useIsAdhaJourney } from '@/core/hooks';
import { PropertiesScreen } from '@/modules/home/components/PropertiesScreen';
import { PropertiesScreenWeb } from '@/modules/home/components/PropertiesScreenWeb';
import { Redirect } from 'expo-router';
import React from 'react';
import { Platform } from 'react-native';

/** Owned "My properties" — blocked for ADHA journey (catalogue lives on home). */
export default function PropertiesTab() {
  const isAdhaJourney = useIsAdhaJourney();

  if (Platform.OS === 'web' && isAdhaJourney) {
    return <Redirect href="/(auth)/(home)" />;
  }

  if (Platform.OS === 'web') {
    return <PropertiesScreenWeb />;
  }
  return <PropertiesScreen />;
}
